import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useState } from "react";

const VersionFormDialog = ({ open, onClose, onSubmit, availableVersions }) => {
    const [version, setVersion] = useState("");
    const [monthlyPrice, setMonthlyPrice] = useState("");
    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        if (!version) newErrors.version = "Version ist ein Pflichtfeld.";
        if (!monthlyPrice) {
            newErrors.price = "Preis ist ein Pflichtfeld.";
        } else if (isNaN(monthlyPrice) || Number(monthlyPrice) <= 0) {
            newErrors.price = "Preis muss eine Zahl größer als 0 sein.";
        }
        if (!description) {
            newErrors.description = "Beschreibung ist ein Pflichtfeld.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;
        onSubmit({ version, monthlyPrice: Number(monthlyPrice), description });
        handleClose();
    };

    const handleClose = () => {
        setVersion("");
        setMonthlyPrice("");
        setDescription("");
        setErrors({});
        onClose();
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;
        const regex = /^\d*(\.\d{0,2})?$/;
        if (regex.test(value)) {
            setMonthlyPrice(value);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Neue Version hinzufügen</DialogTitle>
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 1 }}>
                    <FormControl fullWidth error={!!errors.version} required>
                        <InputLabel id="version-select-label">Version</InputLabel>
                        <Select
                            labelId="version-select-label"
                            value={version}
                            label="Version"
                            onChange={(e) => setVersion(e.target.value)}
                        >
                            {availableVersions.map((v) => (
                                <MenuItem key={v} value={v}>
                                    {v}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.version && <FormHelperText>{errors.version}</FormHelperText>}
                    </FormControl>
                    <TextField
                        label="Monatlicher Preis (€)"
                        value={monthlyPrice}
                        onChange={handlePriceChange}
                        error={!!errors.price}
                        helperText={errors.price}
                        fullWidth
                        required
                        type="number"
                    />
                    <TextField
                        label="Beschreibung"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                        multiline
                        rows={3}
                        required
                        error={!!errors.description}
                        helperText={errors.description}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Abbrechen</Button>
                <Button onClick={handleSubmit} variant="contained">
                    Hinzufügen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VersionFormDialog;
